
export default {
  props: {
    html: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      documents: [
        { path: '/regulamin', label: 'terms' },
        { path: '/polityka-prywatnosci', label: 'privacy_policy' },
        { path: '/cookies', label: 'cookies_policy' }
      ]
    }
  }
}
